import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { GetPosParams } from './gateway-pos-api';
import { getPos } from './gateway-pos-api';

import type { Pos } from '../model/pos';

export function useGetPointsOfSalesQuery(
  { withInactive = true }: Partial<GetPosParams> = {},
  options: Omit<UseQueryOptions<Pos[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    ...options,
    queryKey: ['pos-list', withInactive],
    queryFn: () => getPos({ withInactive }),
  });
}
